<template>
    <section class="fac-modal-info" :class="statusClass" :style="aboveAll ? 'z-index: 1001' : ''">
        <section class="overlay"/>

        <section class="content">
            <section v-if="loading" class="box radius">
                <ui-load-indicator
                    v-if="!success"
                    :h="50"
                    :stroke="8"
                    bg-color="#e7e9f4"
                    color="#69D296"
                />

                <span v-else class="success-icon active">
                    <em class="fal fa-check-circle"/>
                </span>
            </section>

            <section v-show="!loading" class="box has-icon-circle">
                <div v-if="iconCircle" :style="circleStyle" class="box-top-center box-icon-circle">
                    <em v-if="icon" class="icon-circle" :class="icon"/>
                </div>

                <div v-if="!footer" class="close-button">
                    <div class="close-icon-button" @click="close">
                        <em class="far fa-times"/>
                    </div>
                </div>

                <div class="body-modal">
                    <transition name="fade">
                        <div v-show="bodyLoading" class="loading-card">
                            <ui-load-indicator
                                bg-color="#e7e9f4"
                                color="#69D296"
                                :h="50"
                                :stroke="8"
                            />
                        </div>
                    </transition>

                    <div class="over-title"><slot name="top-modal"/></div>
                    <div class="title">{{ titleComputed }}</div>
                    <div v-if="subTitle" class="sub-title">{{ subTitle }}</div>
                    <div class="text">
                        <slot/>
                    </div>
                </div>

                <div v-if="footer" class="footer">
                    <ui-button design="md link" @click="close">Cancelar</ui-button>
                    <ui-button :design="actionButtonClass" :disabled="!canSubmit" @click="action">
                        {{ btnText }}
                    </ui-button>
                </div>

                <section v-if="hasAfterFooter" class="after-footer" :style="afterFooterStyle">
                    <div class="space-shadow"><div class="border"/></div>
                    <div class="body-after-footer">
                        <slot name="after-footer"/>
                    </div>
                </section>
            </section>
        </section>
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiLoadIndicator } from '@/components/ui'
	import { modalMixin } from '@/mixins'

	export default {
		name: 'ui-modal-info',
		components: { uiButton, uiLoadIndicator },

		mixins: [modalMixin],

		props: {
			name: {
				type: String,
				required: true,
			},

			title: {
				type: String,
				required: true,
			},

			subTitle: {
				type: String,
				required: false,
				default: ''
			},

			colorCircle: {
				type: String,
				default: 'primary',
				required: false,
			},

			iconCircle: {
				type: Boolean,
				default: false,
			},

			icon: {
				type: String,
				required: false,
				default: ''
			},

			color: {
				type: String,
				default: ''
			},

			btnType: {
				type: String,
				default: 'success',
			},

			btnText: {
				type: String,
				default: 'Confirmar',
			},

			aboveAll: {
				type: Boolean,
				default: false,
				required: false,
			},

			loading: {
				type: Boolean,
				default: false,
			},

			success: {
				type: Boolean,
				default: false,
			},

			bodyLoading: {
				type: Boolean,
				default: false,
			},

			footer: {
				type: Boolean,
				default: false,
			},

			afterFooterStyle: {
				type: String,
				default: '',
			},

			action: {
				type: Function,
				default: () => {
					return
				},
			},

			canSubmit: {
				type: Boolean,
				detault: true,
			},

			/**
			 * Utilize para passar o evento a ser emitido para o Google
			 */
			cancelTrackEvent: {
				type: Object,
				default: null,
			},
		},

		data() {
			return {
				status: false,
			}
		},

		computed: {
			statusClass() {
				return this.status ? 'active' : ''
			},

			successClass() {
				return this.success ? 'active' : ''
			},

			titleComputed() {
				return this.title
			},

			actionButtonClass() {
				return 'md ' + this.btnType
			},

			circleStyle() {
				return {
					'background-color': this.colorCircle,
				}
			},

			hasAfterFooter() {
				return this.$slots['after-footer'] ? true : false
			},
		},
		mounted() {
			this.$root.$on('modal-open-' + this.name, (data) => {
				if (data) this.data = data
				this.open()
			})

			this.$root.$on('modal-close-' + this.name, (data) => {
				if (data) this.data = data
				this.close()
			})

			this.$root.$on('modal-toggle-' + this.name, (data) => {
				if (data) this.data = data
				this.toggle()
			})
		},

		created() {
			document.addEventListener('keydown', this.setEscape)
		},

		beforeDestroy() {
			document.removeEventListener('keydown', this.setEscape)
			this.$root.$off("modal-open-" + this.name)
			this.$root.$off("modal-close-" + this.name)
			this.$root.$off("modal-toggle-" + this.name)
		},

		methods: {
			setEscape(event) {
				if (event.key === 'Escape') this.close()
			},

			close() {
				this.$mx_removeModal(this.name)
				if (this.cancelTrackEvent) this.$gtm.trackEvent(this.cancelTrackEvent)
				this.status = false
			},

			open() {
				this.$mx_setModal({
					name: this.name,
					visible: true,
				})

				this.status = true
			},

			toggle() {
				this.status = !this.status
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
